import { ICellRendererParams } from 'ag-grid-community';

import { Button, ButtonProps } from '../../buttons/Button';
import { Tooltip } from '../../tooltip/Tooltip';
import { EMPTY_VALUE } from '../valueFormatters';

import { DATA_ATTRIBUTE_PREVENT_AG_GRID_ON_ROW_CLICKED } from './constants';

import styles from './buttonsCellRenderer.module.scss';

export type IButtonsCellRendererParams = ICellRendererParams & {
  buttons: (ButtonProps & { tooltip?: string })[];
};

export const ButtonsCellRenderer = ({
  formatValue,
  buttons,
  value,
}: IButtonsCellRendererParams) => {
  if (value === undefined) {
    return;
  }

  if (!Array.isArray(buttons)) {
    throw new TypeError(
      `ButtonsCellRenderer called with a non-array value: ${JSON.stringify(
        buttons
      )}`
    );
  }

  if (buttons.length === 0) {
    return formatValue?.(buttons) ?? EMPTY_VALUE;
  }

  return (
    <div
      {...DATA_ATTRIBUTE_PREVENT_AG_GRID_ON_ROW_CLICKED}
      className={styles['root']}
      data-testid="action-buttons-cell"
    >
      {buttons.map((button, index) => {
        if (button.tooltip) {
          return (
            <Tooltip key={index} label={button.tooltip}>
              <Button {...button} />
            </Tooltip>
          );
        }
        return <Button key={index} {...button} />;
      })}
    </div>
  );
};
